import { getTheme, IIconProps, IPivotStyles, mergeStyles ,mergeStyleSets} from '@fluentui/react';

const chatHeaderContainerStyle = mergeStyles({
  width: '100%',
  height: 'auto',
  paddingLeft: '3.25rem',
  paddingRight: '3.25rem',
  marginTop: '1rem',
  selectors: {
    '@media (max-width: 65rem)': {
      paddingLeft: '5%',
      paddingRight: '5%'
    }
  },
  borderBottom: '0.063rem solid #DDDDDD'
});

const topicNameContainerStyle = mergeStyles({
  height: '100%',
  maxWidth: '100%',
  display: 'flex',
  alignItems: 'center',
  marginLeft: '0.625rem'
});

const topicNameLabelStyle = mergeStyles({
  color: '#323130',
  fontSize: '1rem', // 16px
  fontWeight: 600,
  marginRight: '0.125rem',
  width: '31.25rem',
  wordBreak: 'break-all',
  overflowY: 'hidden'
});

const topicNameEditTextStyle1 = mergeStyles({
  color: '#A19F9D',
  fontSize: '1rem', // 16px
  fontWeight: 600,
  width: '100%',
  height: '100%'
});

const leaveButtonContainerStyle = mergeStyles({
  height: '100%',
  display: 'flex',
  alignItems: 'center'
});

const leaveButtonStyle = mergeStyles({
  marginRight: '0.625rem',
  width: '6.688rem',
  borderWidth: '0.125rem',
  borderColor: '#CCCCCC',
  color: '#323130',
  fontSize: '0.875rem', // 14px
  fontWeight: 600
});

const greyIconButtonStyle = mergeStyles({
  color: '#323130',
  marginRight: '0.5rem'
});

const editIcon: IIconProps = {
  iconName: 'Edit'
};

const leaveIcon: IIconProps = {
  iconName: 'Leave'
};

const pivotItemStyle = mergeStyles({
  padding: '0px 13px'
});

const palette = getTheme().palette;
const pivotItemStyles: Partial<IPivotStyles> = {
  linkIsSelected: {
    padding: 0,
    marginRight: 0,
    height: '100%',
    color: palette.themePrimary,
    selectors: {
      ':hover': { color: palette.themePrimary }
    }
  },
  link: { padding: 0, marginRight: 0, height: 60 },
  root: {
    width: 84,
    height: 60,
    marginRight: '0.5rem',
    display: 'inline-block',
    verticalAlign: 'top'
  }
};

const iconButtonContainerStyle = mergeStyles({
  whiteSpace: 'nowrap',
  selectors: {
    '@media (min-width: 50rem)': {
      display: 'none'
    }
  }
});

const largeButtonContainerStyle = mergeStyles({
  whiteSpace: 'nowrap',
  selectors: {
    '@media (max-width: 50rem)': {
      display: 'none'
    }
  }
});

const chatHeaderBoxStyle = mergeStyles({
  width: 'auto',
  height: '49px',
  padding: '10px',
  boxSizing: 'border-box',
  background: '#F5F5F5',
  // minWidth:"1480px"
});
const selectIconStyle = mergeStyles({
  background: '#F5F5F5',
  border: '0',
  borderRadius: '3px',

  span: {
    fontWeight: 'normal',
    fontSize: '12px'
  },
  button: {
    border: '0',
    background: '#F5F5F5',
    color: '#242424',
    fontWeight: 'normal',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 0rem 0rem -0.075rem',
    ':hover': {
      background: 'rgb(243, 242, 241)'
    }
  },
  ul: {
    background: '#F5F5F5',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 0rem 0rem -0.075rem'
  },
  a: {
    border: '0',
    background: '#F5F5F5',
    color: '#242424',
    fontWeight: 'normal'
  }
});

const chatBtn = mergeStyles({
  width: '96px',
  height: '32px',
  borderRadius: '4px'
});
const selectStyle = mergeStyles({
  position: 'relative',
  background: '#F5F5F5',
  height: '32px',
  fontSize: '12px',
  color: '#242424',
  ':hover': {
    color: '#242424'
  },
  i: {
    color: '#242424'
  }
});
const cardStyle = mergeStyles({

  width:"100%",
  height:"100%",
  padding: '24px',
  boxSizing: 'border-box',
  background: '#fff',
  zIndex: '999999',
  boxShadow: '0 4px 8px 0 #F3F2F1'
});
const contentStyles = mergeStyleSets({
  spacecpPage: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    width: '600px',
    height:"430px",
    borderRadius:"3px",
    boxSizing:"border-box",
    overflow: 'hidden'
  },
});
const textStyle = mergeStyles({
  border: 'none',
  color: '#484644',
  borderRadius:"3px",
  fontSize: '12px',
  '.ms-TextField-fieldGroup': {
    border: 'none',
    background: '#F3F2F1'
  },
  '.ms-TextField-wrapper': {
    marginTop: '12px'
  }
});
export {
  chatHeaderBoxStyle,
  selectIconStyle,
  selectStyle,
  cardStyle,
  textStyle,
  chatHeaderContainerStyle,
  topicNameContainerStyle,
  topicNameLabelStyle,
  topicNameEditTextStyle1,
  leaveButtonContainerStyle,
  leaveButtonStyle,
  greyIconButtonStyle,
  editIcon,
  leaveIcon,
  chatBtn,
  pivotItemStyle,
  pivotItemStyles,
  contentStyles,
  iconButtonContainerStyle,
  largeButtonContainerStyle
};
